import axios from "axios";
import { PORTAL_API_PATH } from "../config/configs";
import { setGSIDCookie } from "../utils/utils";
import { interceptorRequestBody, interceptorResponseBody, interceptorResponseBodyError } from "./common";
import { response } from "express";

const apiService = axios.create({
  baseURL: PORTAL_API_PATH,
  withCredentials: true,
  //enable for https localhost testing for apple pay, do: npm run https for https localhost testing
});


// Add a request interceptor
apiService.interceptors.request.use(
  async (config) => {
    return interceptorRequestBody(config);
  },
  (error) => Promise.reject(error)
);

// Response interceptor for any errors
apiService.interceptors.response.use(
  (response) => {
    return interceptorResponseBody(response);
  },
  (error) => {
    return interceptorResponseBodyError(error);
  }
);

export default apiService;
